class ExcelDownloader{
  constructor(table){
    this.table = table
  }

  exportXLS(fileName){
    const tableContent = this.table.outerHTML.replace(/ /g, '%20')
    const tableHTMLUrl = `data:application/vnd.ms-excel;charset=utf-8,${tableContent}`
    this.downloader(tableHTMLUrl, fileName)
  }

  downloader(url, filename){
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = filename;
    document.body.appendChild(downloadLink)
    downloadLink.click()
  }
  
}

export default ExcelDownloader